import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPromises, updatePromises, getPromiseById } from "api/promises.api";

export const getPromisesAsync = createAsyncThunk(
  "promises/get-all",
  async (filters) => {
    const data = await getPromises(undefined, filters);
    return data;
  },
);

export const getNextPromisesAsync = createAsyncThunk(
  "promises/get-all-next",
  async ({ last, filters }) => {
    const data = await getPromises(last, filters);
    return data;
  },
);

export const getPromiseByIdAsync = createAsyncThunk(
  "promise/get-by-id",
  async (id) => {
    const promise = await getPromiseById(id);
    const response = await fetch(promise.content);
    const text = await response.text();
    return { ...promise, content: text };
  },
);

export const updatePromiseAsync = createAsyncThunk(
  "promise/update",
  async ({ id, data }) => {
    await updatePromises(id, data);
  },
);
